import { CategoriesState } from './state';

export const categoriesInitialState: CategoriesState = {
  lists: {},
  results: {},
  countries: []
}